<template>
  <AppBar />
  <!-- <div v-show="!myExcelActivated"> -->
  <MainBoxVue />
  <!-- </div> -->
  <!-- <div v-show="myExcelActivated">
    <MyExcelScreen />
  </div> -->
  <!-- <FooterPower /> -->
</template>

<script>
import AppBar from "@/components/AppBar.vue";
// import NavBar from "@/components/NavBar.vue";
// import MyExcelScreen from "@/components/reusable/myExcel/MyExcelScreen.vue";
import MainBoxVue from "../components/MainBox.vue";
import { useStore } from "vuex";
import { ref, watchEffect } from "vue";
// import FooterPower from "@/components/FooterPowerSearch.vue";
export default {
  components: { AppBar, MainBoxVue },
  setup() {
    const store = useStore();
    const myExcelActivated = ref(false);
    watchEffect(() => {
      let se = store.getters["Rawdata/getmyexcelActivationGetter"];
      // console.log(se, "se");
      myExcelActivated.value = se;
      // console.log(myExcelActivated.value, "sss");
    });
    return {
      myExcelActivated,
    };
  },
};
</script>
